import React, { useEffect, useRef } from 'react';
import classnames from 'classnames';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import s from './TabButton.scss';
const TabButton = ({ tab, isActive, onClick, children, focused, tabIndex, onFocus, onBlur, onKeyDown })=>{
    const ref = useRef(null);
    useEffect(()=>{
        if (focused && ref.current) {
            ref.current.focus();
        }
    }, [
        focused,
        ref
    ]);
    return /*#__PURE__*/ React.createElement(PlainButtonOrLink, {
        innerRef: (node)=>{
            ref.current = node;
        },
        tabIndex: tabIndex,
        role: "tab",
        "aria-selected": isActive,
        onClick: ()=>onClick(tab),
        className: classnames(s['tab'], isActive && s['selected']),
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyDown: onKeyDown
    }, children);
};
TabButton.displayName = 'TabButton';
export default TabButton;
